import { AlertTriangle, XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { DashboardAlert } from '@control-center/shared';

interface AlertsStripProps {
  alerts: DashboardAlert[];
}

/**
 * Story 6.6 — Faixa de alertas operacionais acima dos KPI cards.
 * AC4: sem alertas → faixa some completamente.
 * Tokens design system (var(--bad) / var(--warn)) com tints transparentes.
 */
export function AlertsStrip({ alerts }: AlertsStripProps) {
  if (alerts.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {alerts.map((alert) => {
        const isError = alert.severity === 'error';
        const Icon = isError ? XCircle : AlertTriangle;
        const styles = isError
          ? 'border-bad/40 bg-bad/10 text-ink'
          : 'border-warn/40 bg-warn/10 text-ink';
        const iconColor = isError ? 'text-bad' : 'text-warn';

        return (
          <Link
            key={alert.id}
            to={alert.link}
            className={`flex items-center gap-2 rounded-lg border ${styles} px-3 py-2 text-sm transition-opacity hover:opacity-80`}
          >
            <Icon className={`h-4 w-4 ${iconColor}`} />
            <span className="flex-1">{alert.message}</span>
            <span className="text-xs text-muted">ver →</span>
          </Link>
        );
      })}
    </div>
  );
}
